'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var appDom = require('./app-dom');
var sidePanel = require('./side-panel');
var statusMsg = require('./side-panel-status-msg');

var addEventHandlers = function() {

	console.log('buy-panel addEventHandlers called');

	appDom.document
		.on('click', '.buy-panel__add-print-btn', onAddPrintBtnClicked)
		.on('click', '.buy-panel__remove-print-btn', onRemovePrintBtnClicked);

};

var onRemovePrintBtnClicked = function(e) {

	var $link = $(this);
	var sizeId = $link.attr('data-size-id');
	var itemKey = $link.attr('data-item-key');
	var activePanel = $link.attr('data-digital') === 'true' ? 'buy_digital_images' : 'buy_prints';

	e.preventDefault();

	$.ajax({
		url: $link.attr('data-href'),
		method: 'POST',
		dataType: 'JSON',
		data: {
			sizeId: sizeId,
			itemKey: itemKey
		}
	}).done(function() {

		renderPrintsPanel(sizeId, false, activePanel);

	});

};

var onAddPrintBtnClicked = function(e) {

	var $link = $(this);
	var sizeId = $link.attr('data-size-id');
	var activePanel = $link.attr('data-digital') === 'true' ? 'buy_digital_images' : 'buy_prints';

	e.preventDefault();

	$.ajax({
		url: $link.attr('data-href'),
		method: 'POST',
		dataType: 'JSON',
		data: {
			sizeId: sizeId,
			digital: $link.attr('data-digital')
		}
	}).done(function() {

		renderPrintsPanel(sizeId, true, activePanel);

	});

};

var renderPrintsPanel = function(sizeId, addedToCart, activePanel) {

	console.log('**renderPrintsPanel');
	console.log(activePanel);

	$.ajax({
		url: '?page=buy_panel',
		method: 'POST',
		dataType: 'JSON',
		data: {
			activePanel: activePanel,
			saveActivePanel: false
		}
	}).done(function(response) {

		sidePanel.open(response.markup, {retainScrollPosition: true});

		if (addedToCart) {
			statusMsg.show('added_to_cart');
		}

	});

};

var init = function() {

	addEventHandlers();

};

module.exports = {
	init: init
};
